export default __webpack_public_path__ + "static/media/RaviGeo.d3e12b4c.jpg";